import { initReactI18next } from 'react-i18next';

import i18n, { InitOptions } from 'i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';

import { translationDe } from 'data/translations/de/de';
import { translationAt } from 'data/translations/de/de-AT/at';
import translationDeDE from 'data/translations/de/de-DE/common.json';

import { getCheck24Namespace } from 'utility/Provide/Namespace/getCheck24Namespace';

import { BackendInformationFuncModule } from 'types/legacy/backendInformation';

const backendInformationFunc: BackendInformationFuncModule | undefined =
    getCheck24Namespace()?.components?.backendInformationFunc;

const isDevelopment = process.env.NODE_ENV === 'development';

export const resources = {
    'de-DE': {
        translation: translationDeDE,
    },
    'de-AT': {
        translation: translationAt,
    },
    de: {
        translation: translationDe,
    },
};
export const intervalPluralConfig = {
    intervalSuffix: '[i]',
};

export const config: InitOptions = {
    compatibilityJSON: 'v3',
    debug: isDevelopment,
    lng: backendInformationFunc?.getI18nScheme() ?? 'de-DE',
    fallbackLng: 'de',
    keySeparator: false, // we do not use keys in form messages.welcome
    returnObjects: false,
    interpolation: {
        escapeValue: false,
        formatSeparator: '.',
    },
    react: {
        useSuspense: true,
    },
};

const initOptions: InitOptions = {
    resources,
    ...config,
};

intervalPlural.setOptions(intervalPluralConfig);
i18n.use(intervalPlural)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init(initOptions);

export default i18n;
